import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  NotificationGroupType,
  NotificationSendMethod,
  NotificationTrigger,
} from '../../../models/enums/notifications';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  CustomTuneFiltersIcon,
  MissionsIcon,
  OrganizationsIcon,
  SummaryIcon,
} from '@common/utils/icons/icons';
import NotificationSubscription, {
  DefaultNotificationSubscription,
} from '../../../models/general/notifications/notification-trigger';
import SubscriptionSwitch from './SubscriptionSwitch';

const NotificationList: React.FC<{
  groupType: NotificationGroupType;
  sendMethod: NotificationSendMethod;
  optionSet: DefaultNotificationSubscription[];
  subscriptions: NotificationSubscription[];
}> = ({ groupType, subscriptions, sendMethod, optionSet }) => {
  const { t } = useTranslation();

  return (
    <Stack padding={2}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box>
          {groupType === NotificationGroupType.SUMMARY ? (
            <SummaryIcon />
          ) : groupType === NotificationGroupType.MISSION_BASED ? (
            <MissionsIcon />
          ) : groupType === NotificationGroupType.ORGANIZATION_BASED ? (
            <OrganizationsIcon />
          ) : (
            <CustomTuneFiltersIcon />
          )}
        </Box>
        <Stack spacing={1}>
          <Typography variant="h3">{t('notification-group-type-' + groupType)}</Typography>
          <Typography variant="caption">
            {t('notification-group-type-description-' + groupType)}
          </Typography>
        </Stack>
      </Stack>

      <Stack pt={1} pl={2}>
        <List disablePadding>
          {optionSet.map((option) => {
            const existingNotification = subscriptions.find(
              (subscription) =>
                subscription.trigger === option.trigger &&
                ((option.repeat != null && subscription.repeat === option.repeat) ||
                  subscription.repeat == null),
            );
            const isChecked =
              existingNotification != null &&
              ((sendMethod === NotificationSendMethod.PUSH && existingNotification.pushActive) ||
                (sendMethod === NotificationSendMethod.EMAIL && existingNotification.emailActive));
            return (
              option.trigger !== NotificationTrigger.DASHBOARD_SUMMARY && (
                <ListItem key={option.trigger} disableGutters>
                  <SubscriptionSwitch
                    trigger={option.trigger}
                    repeat={option.repeat}
                    notification={existingNotification}
                    isChecked={isChecked}
                    groupType={groupType}
                    sendMethod={sendMethod}
                  />
                </ListItem>
              )
            );
          })}
        </List>
      </Stack>
    </Stack>
  );
};

export default NotificationList;
